import { render } from "./SCR040.vue?vue&type=template&id=08851580"
import script from "./SCR040.vue?vue&type=script&lang=ts"
export * from "./SCR040.vue?vue&type=script&lang=ts"
script.render = render

export default script